var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.path)?_c('BaseBIPage',{attrs:{"title":'商品列表',"baseSrc":'https://bi.aliyuncs.com/dashboard/view/pc.htm?pageId='+_vm.path+'&qbi_version_param=2'}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }